import React, { useEffect, useState } from "react";

import moment from "moment";
import "moment/locale/pt-br";
import { useAuth } from "../providers/auth";
import { DollarSign, Check } from "react-feather";
import { CAvatar, CTableRow, CTableDataCell, CBadge } from "@coreui/react";

const OutdatedCustomersRow2 = props => {
  const { customer, mutations, setTriggers, setCustomerId, enableBttns, informationFn, transferCustomer } = props;

  const avatarStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundImage: `url(${customer.profile_pic})`
  };

  const { user } = useAuth();
  const [currentAdmin] = useState(customer.currentAdmin_id);
  const chatIsFromAdmin = currentAdmin == user.id;

  const [openChat, setOpenChat] = useState();

  /**
   *
   *
   * Functions
   */
  const handleGetSocialMedia = () => {
    mutations.socialMediaMutation.mutate(customer.id);
    setCustomerId(customer.id);
    setOpenChat(true);
    setTriggers.setMediaTrigger(true);
  }

  const handleGetCustomer = () => {
    setCustomerId(customer.id);
    mutations.customerHandleMutation.mutate(customer.id);
    setTriggers.setPhoneTrigger(true);
  }

  useEffect(() => {
    enableBttns.forEach(bttn => {
      if (bttn.id == customer.id) {
        setOpenChat(bttn.admin_id == user.id);
      }
    });
  }, [enableBttns]);

  return (
    <CTableRow>
      <CTableDataCell className="align-middle">
        <CAvatar color="light" textColor="dark" style={avatarStyle}></CAvatar>
      </CTableDataCell>
      <CTableDataCell className="align-middle">
        <span className="text-color" onClick={() => informationFn(customer)}>
          {customer.name}
        </span>

        {customer.link_usadao
          ? <CBadge style={{ marginLeft: "15px" }} color="warning" href={customer.link_usadao}>#{customer.usadao_id}</CBadge>
          : <CBadge style={{ marginLeft: "15px" }} color="dark">Sem cadastro</CBadge>}

        {customer.link_usadao ?
          <CBadge style={{ marginLeft: "15px" }} color="success">{customer.arremate ? <DollarSign size={12} /> : ""}</CBadge>
          : ""}
          
      </CTableDataCell>
      <CTableDataCell className="align-middle">
        {customer.link_usadao
          ? <CBadge textColor="dark" href={customer.link_usadao}>
            <span className={`message-box-date text-color`}>
              {moment(customer.ultimaVizualizacao).format("LL")}
            </span>
          </CBadge>
          : <CBadge style={{ marginLeft: "15px" }} textColor="dark"></CBadge>}
      </CTableDataCell>
      <CTableDataCell className="align-middle">
        {customer.status
          ? <CBadge color="success">Ativo</CBadge>
          : <CBadge color="danger">Inativo</CBadge>}
      </CTableDataCell>
      <CTableDataCell className="align-middle">
        {customer.approved
          ? <CBadge color="success">Aprovado</CBadge>
          : <CBadge color="danger">Desaprovado</CBadge>}
      </CTableDataCell>
      <CTableDataCell className="align-middle">
        {chatIsFromAdmin
          ? <div align="center">
            <CBadge color="success">
              <Check size={14} />
            </CBadge>
          </div>
          : <div align="center">
            <button className="btn btn-primary" onClick={handleGetCustomer}>Ligar</button>
          </div>
        }
      </CTableDataCell>

      <CTableDataCell className="align-middle">
        {/* chatIsFromAdmin ? (
          <div align="center">
            <CBadge color="success">
              <Check size={14} />
            </CBadge>
          </div>
        ) */}
        {openChat ? (
          // Bttn de abrir um novo chat
          <div align="center">
            <button className="btn btn-warning" type="submit" onClick={handleGetSocialMedia}>
              +Chat
            </button>
          </div>
        ) : (
          // Bttn de abrir um novo chat bloqueado
          <div align="center">
            <button className="btn btn-warning" type="submit" onClick={handleGetSocialMedia}>
              +Chat
            </button>
          </div>
        )}
      </CTableDataCell>
      <CTableDataCell className="align-middle">
        <div align="center">
          <button className="btn btn-light" type="button" onClick={() => transferCustomer(customer)}>
            Transferir
          </button>
        </div>
      </CTableDataCell>
    </CTableRow>
  );
}

export default OutdatedCustomersRow2;
